export const ZOOM = 0.25;
